import * as React from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = React.lazy(() => import('modules/salary_advance/pages/settings/RootPage'))

const SalaryAdvanceSettingsPage = React.lazy(
  () => import('modules/salary_advance/pages/settings/index')
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.salaryAdvance.path,
      element: <RootPage />,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'salary_advance'),
      },
      children: [
        {
          index: true,
          element: <SalaryAdvanceSettingsPage />,
        },
      ],
    },
  ]
}

export default settingsRoutes
